// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XYUV","inner":"Footer_inner__7jvv1","nextIcon":"Footer_nextIcon__1Aa6B","innerLeft":"Footer_innerLeft__N8yNK"};